var jquery = require("jquery");
// var cookie = require("jquery.cookie');
window.$ = window.jQuery = jquery;
require('lazysizes');
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.preloadAfterLoad = true;
import Lenis from 'lenis';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import "@lottiefiles/lottie-player";

// Initialize Lenis
const lenis = new Lenis({
	lerp: 0.05, 
	wheelMultiplier: 1,
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
});


lenis.on('scroll', (e) => {
	

});

// Use requestAnimationFrame to continuously update the scroll
function raf(time) {
	lenis.raf(time);
    ScrollTrigger.update();
	requestAnimationFrame(raf);
}



const footer = $('footer');
const footerContainer = $('footer .container');




// READY

$(function () {

	console.log('Website proudly by Imagic Creative');

	requestAnimationFrame(raf);

	resizeVideo();

	footerReveal();

	allAnimations();


	setInterval(function() {
		if (window.location.hash) {
			// Extract the section number from the hash
			var sectionNumber = window.location.hash.substring(9); // Assuming #section-XXX format
			var section = $('[data-section-id="' + sectionNumber + '"]');
			if (section.length) {
				$('html, body').animate({
					scrollTop: $('[data-section-id="' + sectionNumber + '"]').offset().top
				}, 'slow');
			}

			// Remove the hash from the URL after scrolling
			history.replaceState({}, document.title, window.location.pathname);
		}
	}, 250);



	$("[data-required]").each(function (index) {
		$(this).attr('required', true);
		$('form').removeAttr('novalidate');
	});

});

////////////////////




// SCROLL

$(window).on('scroll', function(e) {

	// didScroll = true;

});

////////////////////




// RESIZE

$(window).on('resize', function() {

	resizeVideo();

	ScrollTrigger.refresh();

});

////////////////////




// MENU


$(document).on('click', '[data-menu-trigger]', function(e) {
	var revealed = $(this).attr('data-menu-revealed');
	if (revealed == 'false') {
		lenis.stop();
		hamburgerAction('open');
		mainMenuAction('open');
		$(this).attr('data-menu-revealed','true');
		$('body').attr('data-menu-revealed','true');
		$('aside.main-menu').attr('data-menu-revealed','true');
		$('aside.main-menu').attr('data-container-revealed','true');
	} else {
		lenis.start();
		hamburgerAction('close');
		mainMenuAction('close');
		$(this).attr('data-menu-revealed','false');
		$('body').attr('data-menu-revealed','false');
		$('aside.main-menu').attr('data-menu-revealed','false');
		setTimeout(() => {
			$('aside.main-menu').attr('data-container-revealed','false');
		}, 1000);
	}
});

////////////////////





// FORMS

$(function () {
	
	if ($('section form#subscribe').length) {
		$('footer form').remove();
	}

	var forms = $('[data-freeform]');
	if (forms.length) {
		forms.each(function() {
			dynamicCSRF($(this));
			var btn = $(this).find('button.freeform-button-submit');
			var btnText = btn.text();
			if (btnText) {
				var newText = '<span>' + btnText + '</span><svg xmlns="http://www.w3.org/2000/svg" width="18.437" height="12.857" viewBox="0 0 18.437 12.857"><g transform="translate(0.75)"><path d="M7.635-.564l.083,8.281L-.564,7.634" transform="translate(5.701 6.46) rotate(-45)" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M.151.334V6.981H16.61" transform="translate(-0.151 -0.334)" fill="none" stroke="currentColor" stroke-width="1.5"/></g></svg>';
				btn.html(newText);
			}
		})
	}
    $('textarea').on('input', function () {
        $(this).css('height', 'auto'); // Reset height to calculate new scroll height
        $(this).css('height', this.scrollHeight + 'px'); // Set height to match the content
    });
});
async function dynamicCSRF(el) {
    console.log('dynamicCSRF...');
	var form = el.attr('id');
    try {
        const response = await $.ajax({
            type: 'get',
            url: '/dynamic/csrf?form=' + form,
			dataType: 'json',
        });
		console.log(response.csrf);
        if (response.csrf) {
			el.find('input[name=formHash]').val(response.hash);
			var csrf = response.csrf;
			el.find('input[name=' + csrf.name + ']').val(csrf.value);
        }
    } catch (error) {
        console.log('dynamicCSRF() error');
        console.log(error);
    }
}

///////////////////////////////////////





// HELPERS

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
}

function resizeVideo() {
	var iframe = $('.video-container iframe');
	if (iframe.length == 0) {
		return false;
	}
	iframe.each(function() {
		var contWidth = $(this).closest('.media-container').outerWidth();
		var contHeight = $(this).closest('.media-container').outerHeight();
	
		var aspectRatio = 16 / 9;
	
		if (contWidth / contHeight > aspectRatio) {
			$(this).css({
				width: contWidth,
				height: contWidth / aspectRatio
			});
		} else {
			// console.log('here')
			// console.log('contHeight ' + contHeight)
			// console.log('aspectRatio ' + aspectRatio)
			// console.log('width ' + (contHeight * aspectRatio))
			$(this).css({
				width: contHeight * aspectRatio,
				height: contHeight
			});
		}
	})
}

///////////////////////////////////////





// ANIMATIONS

function allAnimations() {

	animationType3();
	// heroType1();

	textType1();
	textType2();
	textType3();
	// textType4();
	// textType6();

	ctaType1();
	ctaType2();

	videoType2();
	
	animationType1();
	animationType2();

	imagesType1();

	listType1();
}

var header = $('header');
var filterRow = $('.row-filter');
var filterContainer = filterRow.find('.filter-container');
var headerLogo = header.find('.column-logo svg');
var headerRowLine = header.find('.row-line');
var headerLine = headerRowLine.find('div');
var hamburger = header.find('.hamburger');

// --- //

let lastScroll = 0;
let isMenuOpen = false;

if (header.length) {

	ScrollTrigger.create({
		start: 0,
		end: () => {
			// Calculate max scrollable height and add one screen height
			const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
			return maxScroll + window.innerHeight; // Set end to max + screen height
		},
		onUpdate: (self) => {
			if (isMenuOpen) return;

			const currentScroll = self.scroll();

			// Helper function to check if filterRow is stuck
			const isFilterRowSticky = () => {
				if (!filterRow.length) return false;
				const filterRowOffsetTop = filterRow.offset().top - header.outerHeight();
				const scrollTop = $(window).scrollTop();
				return scrollTop >= filterRowOffsetTop;
			};
			if (!isFilterRowSticky() && filterContainer.length) {
				gsap.to(filterContainer, {
					translateY: 0,
					duration: 1,
				}, '<');
			}

			if (currentScroll > lastScroll && currentScroll > 50) {
				// Scrolling down: Hide header
				gsap.to(header, {
					yPercent: -100,
					duration: 1,
				});
				gsap.to(headerRowLine, {
					opacity: 0
				});
				if (isFilterRowSticky() && filterContainer.length) {
					gsap.to(filterContainer, {
						translateY: 0,
						duration: 1,
					}, '<');
				}
			} else if (currentScroll < lastScroll) {
				// Scrolling up: Show header
				gsap.to(header, {
					yPercent: 0,
					duration: 1,
				});
				gsap.to(headerRowLine, {
					opacity: 0
				});
				if (isFilterRowSticky() && filterContainer.length) {
					gsap.to(filterContainer, {
						translateY: header.outerHeight(),
						duration: 1,
					}, '<');
				} else if (filterContainer.length) {
					gsap.to(filterContainer, {
						translateY: 0,
						duration: 1,
					}, '<');
				}
			}

			if (currentScroll <= 50) {
				gsap.to(headerRowLine, {
					opacity: 1
				});
				header.removeClass('header-shrink');
			} else {
				header.addClass('header-shrink');
			}

			lastScroll = currentScroll; // Update lastScroll
		},
	});
}


// --- //

var mainMenu = $('aside.main-menu');
var mainMenuColumnL = mainMenu.find('.column-left');
var mainMenuColumnR = mainMenu.find('.column-right');
var mainMenuBottom = mainMenu.find('.row-bottom');
var mainMenuColumnRLinks = mainMenuColumnR.find('a');

var mainMenuTimelineHeader = gsap.timeline({ paused: true });
var mainMenuTimeline = gsap.timeline({ paused: true });

mainMenuTimelineHeader.to(header, { 
	height: '100svh',
	yPercent: 0,
	duration: 0.4,
	background: '#BD734A',
	delay: 0,
})
.to(mainMenu, { 
	translateY: 0,
	opacity: 1,
	duration: 0.5,
	delay: 0.1,
})
.to(headerLogo, { 
	color: '#000000',
	duration: 0.5,
	delay: 0,
}, "-=0.5")
.to(hamburger.find('span'), { 
	background: '#000000',
	duration: 0.5,
	delay: 0,
}, "-=0.5")
.to(headerLine, { 
	opacity: 0,
	duration: 0.5,
	delay: 0,
}, "-=0.5")

mainMenuTimeline.to(mainMenuColumnL, { 
	opacity: 1, 
	translateX: 0,
	duration: 1,
	delay: 1,
})
.to(mainMenuColumnR, { 
	opacity: 1, 
	translateX: 0,
	duration: 0.4,
	delay: 0,
}, "-=1")
.to(mainMenuColumnRLinks, { 
	opacity: 1, 
	translateX: 0,
    stagger: 0.1,
	duration: 0.4,
	delay: 0.1,
    onComplete: function() {
        mainMenuColumnRLinks.addClass('transition-finished');
    }
}, "-=0.7")
.to(mainMenuBottom, { 
	opacity: 1, 
	translateX: 0,
    stagger: 0.2,
	duration: 1,
	delay: 0.1,
}, "+=0.1")

function mainMenuAction(action) {
	if (action == 'open') {
		isMenuOpen = true;
		mainMenuTimelineHeader.timeScale(1);
		mainMenuTimelineHeader.play();
		mainMenuTimeline.timeScale(1);
		mainMenuTimeline.play();
	} else {
		isMenuOpen = false;
		mainMenuTimelineHeader.timeScale(1);
		mainMenuTimelineHeader.reverse();
		mainMenuTimeline.timeScale(5);
		mainMenuTimeline.reverse();
	}
}

$('aside [data-menu]').hover(
	function() {
		var menuValue = $(this).attr('data-menu');
		console.log('menuValue ' + menuValue)
		$('aside [data-menu-image]').hide();
		$('aside [data-menu-image="' + menuValue + '"]').fadeIn(600);
	}
);


// --- //

var span1 = hamburger.find('.span1');
var span2 = hamburger.find('.span2');
var span3 = hamburger.find('.span3');

var hamburgerTimeline = gsap.timeline({ paused: true });

hamburgerTimeline.to(span1, { 
	translateY: '0.4375rem',
	duration: 0.3, 
	delay: 0,
})
.to(span3, { 
	translateY: '-0.4375rem',
	duration: 0.1,
	width: '100%',
	delay: 0,
}, "-=0.1")
.to(span1, { 
	scaleX: '0.1',
	duration: 0.1,
	delay: 0.3,
})
.to(span2, { 
	scaleX: '0.1',
	duration: 0.1,
	delay: 0,
}, "-=0.1")
.to(span3, { 
	scaleX: '0.1',
	duration: 0.1,
	delay: 0,
}, "-=0.1")
.to(span1, { 
	scaleX: '1',
	rotate: '45',
	duration: 0.1,
	delay: 0.3,
})
.to(span2, { 
	scaleX: '1',
	rotate: '-45',
	duration: 0.1,
	delay: 0,
}, "-=0.1")
.to(span3, { 
	rotate: '-45',
	duration: 0.1,
	delay: 0,
}, "-=0.1")


function hamburgerAction(action) {

	if (action == 'open') {
		hamburgerTimeline.timeScale(1);
		hamburgerTimeline.play();
	} else {
		hamburgerTimeline.timeScale(2);
		hamburgerTimeline.reverse();
	}
}


// --- //


function footerReveal() {

	let footerColDesktopTall = footer.find('.row-bottom .column-heading-desktop-tall');
	let footerLettersDesktopTall = footerColDesktopTall.find('.letter');
	let footerColDesktopShort = footer.find('.row-bottom .column-heading-desktop-short');
	let footerLettersDesktopShort = footerColDesktopShort.find('.letter');
	let footerColMobile = footer.find('.row-bottom .column-heading-mobile');
	let footerHeadingMobile = footerColMobile.find('.heading');

	function initDesktopTall() {
		footerColDesktopTall.show();
		footerColDesktopShort.hide();

		var tl = gsap.timeline({
			scrollTrigger: {
				trigger: footer[0],
				start: "bottom bottom",
				toggleActions: "play reverse play reverse",
				scrub: true
			}
		});
	
		tl.to(footerLettersDesktopTall, { 
			opacity: 1, 
			translateX: 0,
			stagger: 0.2,
			duration: 1,
			ease: "power2.out",
			delay: 0.3,
		})
    }

	function initDesktopShort() {
		footerColDesktopTall.hide();
		footerColDesktopShort.show();
		
		var tl = gsap.timeline({
			scrollTrigger: {
				trigger: footer[0],
				start: "top center",
				scrub: false
			}
		});
	
		tl.to(footerLettersDesktopShort, { 
			opacity: 1, 
			translateX: 0,
			stagger: 0.2,
			duration: 1,
			ease: "power2.out",
			delay: 0.6,
		})
    }

    function initMobile() {
		footerColDesktopTall.hide();
		footerColDesktopShort.hide();
		footerColMobile.show();
        gsap.set(footerColMobile, { translateX: (footerHeadingMobile.outerWidth() * (-1)) + 'px' });
        var offset = footerHeadingMobile.outerWidth() * 0.033; 
		gsap.to(footerColMobile, {
            translateX: (footerHeadingMobile.outerWidth() * (-2) + offset) + 'px',
            duration: 8,
            ease: 'linear',
            repeat: -1,
			scrollTrigger: {
				trigger: footer[0],
				start: "top center",
				end: "top top",
			},
        });
    }

	if ($(window).width() < 1024 || !footer.length) {
		footer.removeClass('footer-fixed');
		ScrollTrigger.create({
			trigger: footer[0],
			pin: false,
			start: "bottom bottom",
			scrub: false,
		});
		initMobile();
	} else {
		footerColMobile.hide();
		footerColDesktopTall.show();
		footerColDesktopShort.hide();
		let footerRowsHeight = footerContainer.find('.row').toArray().reduce((sum, row) => sum + $(row).outerHeight(), 0);
		var footerPT = parseInt($('footer').css('padding-top'), 10);
		var footerPB = parseInt($('footer').css('padding-bottom'), 10);
		let footerHeight = footerRowsHeight + footerPT + footerPB;
		if (footerHeight > $(window).height()) {
			footer.removeClass('footer-fixed');
			initDesktopShort();
		} else {
			footer.addClass('footer-fixed');
			ScrollTrigger.create({
				trigger: footer[0],
				pin: true,
				start: "bottom bottom",
				end: "+=100%",
				scrub: true,
			});
			initDesktopTall();
		}
	}
	
}
$(window).on("resize", footerReveal); // Update on resize



// --- //


function heroType1() {

	// note - add settimeout if widths are not calculated right
	
	if ($(window).width() < 1024) return false;

    var heroType1Section = $('[data-section="heroType1"]');
	if (!heroType1Section.length) return false;

    var line1 = heroType1Section.find('.line1');
    var line2 = heroType1Section.find('.line2');
    var line3 = heroType1Section.find('.line3');
	var line1word1 = line1.find('.word1');
    var line2word1 = line2.find('.word1');
    var line3word1 = line3.find('.word1');
    var line1word2 = line1.find('.word2');
    var line2word2 = line2.find('.word2');
    var line3word2 = line3.find('.word2');
	var line1word1Width = line1word1.width();
	var line2word1Width = line2word1.width();
	var line3word1Width = line3word1.width();
    var heroType1SectionMedia = heroType1Section.find('.media-container');
    var content = heroType1Section.find('.block-content');

	var tl = gsap.timeline({
		scrollTrigger: {
			trigger: heroType1Section[0],
		},
		onComplete: function() {
			line1word1.hide();
			line2word1.hide();
			line3word1.hide();
			line1.removeAttr('style');
			line2.removeAttr('style');
			line3.removeAttr('style');
		}
	});

	tl.to(line1word1, { 
		opacity: 1, 
		translateX: 0,
		duration: 0.85, 
		delay: 0,
	})
	.to(line2word1, { 
		opacity: 1, 
		translateX: 0,
		duration: 0.85, 
		delay: 0,
	}, "-=0.255")
	.to(line3word1, { 
		opacity: 1, 
		translateX: 0,
		duration: 0.85, 
		delay: 0,
	}, "-=0.425")
	.to(line1word2, { 
		opacity: 1, 
		translateX: 0,
		duration: 0.85, 
		delay: 0,
	})
	.to(line2word2, { 
		opacity: 1, 
		translateX: 0,
		duration: 0.85, 
		delay: 0,
	}, "-=0.425")
	.to(line3word2, { 
		opacity: 1, 
		translateX: 0,
		duration: 0.85, 
		delay: 0,
	}, "-=0.425")
	.to(line1, { 
		opacity: 1, 
		translateX: (-1) * line1word1Width,
		duration: 1.275, 
		delay: 0.85,
	})
	.to(line1word1, { 
		opacity: 0, 
		duration: 1.275, 
		delay: 0,
	}, "-=1.275")
	.to(line2, { 
		opacity: 1, 
		translateX: (-1) * line2word1Width,
		duration: 1.275, 
		delay: 0,
	}, "-=1.275")
	.to(line2word1, { 
		opacity: 0, 
		duration: 1.275, 
		delay: 0,
	}, "-=1.275")
	.to(line3, { 
		opacity: 1, 
		translateX: (-1) * line3word1Width,
		duration: 1.275, 
		delay: 0,
	}, "-=1.275")
	.to(line3word1, { 
		opacity: 0, 
		duration: 1.275, 
		delay: 0,
	}, "-=1.275")
	.to(heroType1SectionMedia, { 
		opacity: 1, 
		translateX: 0,
		duration: 0.85, 
		delay: 0,
	}, "-=0.85")
	.to(content, { 
		opacity: 1, 
		translateX: 0,
		duration: 0.85, 
		delay: 0,
	}, "-=0.85")
}



// --- //


function textType1() {

    var textType1Section = $('[data-section="textType1"]');
	if (!textType1Section.length) return false;

    var textType1SectionTrigger = textType1Section.find('.link');
	
	textType1SectionTrigger.on('click', function () {
        var block = $(this).closest('.block-content');
        var content = block.find('.p3');
        var revealed = block.attr('data-revealed');
		if (revealed == 'true') {
			block.attr('data-revealed','false');
			content.slideUp();
		} else {
			block.attr('data-revealed','true');
			content.slideDown();
		}

    });

	if ($(window).width() < 1024) return false;

	gsap.to(textType1Section.find('.row-cards-desktop .column'), {
		translateY: 0,
		duration: 1,
		scrollTrigger: {
			trigger: textType1Section[0],
			start: "top center",
			end: "top top",
			scrub: true,
		},
	});
}


// --- //


function textType2() {

    var textType2Section = $('[data-section="textType2"]');
	if (!textType2Section.length) return false;

    var textType2SectionRow = textType2Section.find('.row-cards-desktop');
    var textType2Column = textType2SectionRow.find('.column');
    var textType2Block = textType2Column.find('.block-content');

    var textType2BlockMobile = textType2Section.find('.row-cards-mobile .block-content');
    var textType2HeadingkMobile = textType2Section.find('.row-cards-mobile .block-heading');

	var sticky = true;
	textType2BlockMobile.each(function () {
		if ($(this).outerHeight() > $(window).height()) {
			sticky = false;
			return false;
		}
	});
	if (sticky) {
		textType2BlockMobile.addClass('block-content-sticky');
		textType2HeadingkMobile.addClass('block-heading-sticky');
	} else {
		textType2BlockMobile.removeClass('block-content-sticky');
		textType2HeadingkMobile.removeClass('block-heading-sticky');
	}

	if ($(window).width() < 1024) return false;

	gsap.to(textType2Column, {
		[`translateY`]: 0,
		duration: 1,
		scrollTrigger: {
			trigger: textType2SectionRow[0],
			start: "top center",
			end: "top top",
    		scrub: true,
		},
	});

	textType2Block.on('click', function () {
        var revealed = $(this).attr('data-revealed');
		if (revealed == 'true') {
			$(this).attr('data-revealed','false')
		} else {
			$(this).attr('data-revealed','true')
		}
    });
}


// --- //


function ctaType1() {

	if ($(window).width() < 1024) return false;

    var ctaType1Section = $('[data-section="ctaType1"]');
	if (!ctaType1Section.length) return false;

    var ctaType1Image = ctaType1Section.find('.image-container');
    var barTall = ctaType1Section.find('.bar-tall');
    var barShort = ctaType1Section.find('.bar-short');
    
	gsap.to(ctaType1Image, {
        yPercent: -10,
        ease: "none",
        scrollTrigger: {
            trigger: ctaType1Section[0],
            start: "top bottom",
            end: "bottom top",
            scrub: true,
        },
    });

	gsap.to(barTall, {
		scaleY: 1,
		duration: 1,
		scrollTrigger: {
			trigger: ctaType1Section[0],
            start: "top bottom",
            end: "bottom top",
			scrub: true,
		},
	});

	gsap.to(barShort, {
		scaleY: 1,
		duration: 0.5,
		scrollTrigger: {
			trigger: ctaType1Section[0],
            start: "top bottom",
            end: "bottom top",
			scrub: true,
		},
	});
}

$('[data-section="ctaType1"] .block-content').hover(
	function() {
		$(this).closest('section').attr('data-overlay','true');
	},
	function() {
		$(this).closest('section').attr('data-overlay','false');
	}
);


// --- //


function ctaType2() {

	if ($(window).width() < 1024) return false;

    var ctaType2Section = $('[data-section="ctaType2"]');
	if (!ctaType2Section.length) return false;

	ctaType2Section.each(function() {
		var section = $(this);
		var ctaType2ImageSvg = section.find('.media-container svg rect');
	
		gsap.set(ctaType2ImageSvg, {
			strokeDasharray: 4000,
			strokeDashoffset: 4000,
		});
	
		gsap.to(ctaType2ImageSvg, {
			strokeDashoffset: 0,
			duration: 1,
			scrollTrigger: {
				trigger: section[0],
				start: "top center",
				end: "center center",
				scrub: false,
			},
		});
	});

}


// --- //


function textType3() {
	
    var textType3Section = $('[data-section="textType3"]');
	if (!textType3Section.length) return false;

	var textType3Block = textType3Section.find('.block-content');
	var textType3Text = textType3Block.find('.p3');
    var textType3Column = textType3Section.find('.row-cards .column');

	gsap.set(textType3Text, { height: 0 });


	textType3Block.on('click', function () {
        var heading = $(this).find('h3');
        var content = $(this).find('.p3');
        var readMore = $(this).find('.link-plus');
        var readLess = $(this).find('.link-minus');
        var isVisible = gsap.getProperty(content[0], 'height') > 0;

        if (isVisible) {
            readMore.show();
            readLess.hide();
            gsap.to(heading, {
                color: '#9A9A9A',
                duration: 0.5,
                ease: 'power2.inOut',
            });
            gsap.to(content, {
                height: 0,
                duration: 0.5,
                ease: 'power2.inOut',
            });
        } else {
            readMore.hide();
            readLess.show();
            gsap.to(heading, {
                color: '#BD734A',
                duration: 0.5,
                ease: 'power2.inOut',
            });
            gsap.to(content, {
                height: 'auto',
                duration: 0.5,
                ease: 'power2.inOut',
            });
        }
    });	

	ScrollTrigger.matchMedia({
		"(min-width: 1024px)": function () {
			gsap.to(textType3Column, {
				translateX: 0,
				duration: 1,
				scrollTrigger: {
					trigger: textType3Section[0],
					start: "top center",
					end: "top top",
					scrub: true,
				},
			});
		},
		"(max-width: 1023px)": function () {
			textType3Column.removeAttr('style');
		}
	});

}


// --- //


function textType4() {

	if ($(window).width() < 1024) return false;

    var textType4Section = $('[data-section="textType4"]');
	if (!textType4Section.length) return false;

	textType4Section.each(function() {
		var section = $(this);

		var textType4Column = section.find('.row-content .column');
		
		gsap.set(textType4Column, { opacity: 0 });

		gsap.to(textType4Column, {
			opacity: 1,
			duration: 0.5,
			ease: 'power2.inOut',
			scrollTrigger: {
				trigger: section[0],
				start: "top bottom",
				end: "center center",
				scrub: true,
			},
		});
	});

}


// --- //


function textType6() {

	if ($(window).width() < 1024) return false;

    var textType6Section = $('[data-section="textType6"]');
	if (!textType6Section.length) return false;

	textType6Section.each(function() {
		var section = $(this);

		var textType6Column = section.find('.row-content .column');
		
		gsap.set(textType6Column, { opacity: 0 });

		gsap.to(textType6Column, {
			opacity: 1,
			duration: 0.5,
			ease: 'power2.inOut',
			scrollTrigger: {
				trigger: section[0],
				start: "top bottom",
				end: "center center",
				scrub: true,
			},
		});
	});

}


// --- //


function animationType1() {

    var animationType1Section = $('[data-section="animationType1"]');
	if (!animationType1Section.length) return false;
	
	animationType1Section.each(function() {
		var section = $(this);

		const elements = [
			{ element: section.find('#top1'), axis: 'Y' },
			{ element: section.find('#top2'), axis: 'Y' },
			{ element: section.find('#top3'), axis: 'Y' },
			{ element: section.find('#right1'), axis: 'X' },
			{ element: section.find('#right2'), axis: 'X' },
			{ element: section.find('#left1'), axis: 'X' },
			{ element: section.find('#left2'), axis: 'X' },
			{ element: section.find('#bottom1'), axis: 'Y' },
			{ element: section.find('#bottom2'), axis: 'Y' },
		];

		ScrollTrigger.create({
			trigger: section[0],
			start: "top top",
			pin: $(window).width() >= 1024 ? true : false,
			anticipatePin: 2,
			pinSpacing: false,
			end: "+=200%",
			scrub: true,
		});

		elements.forEach(({ element, axis }) => {
			gsap.to(element, {
				[`translate${axis}`]: 0,
				duration: 1,
				scrollTrigger: {
					trigger: section[0],
					start: $(window).width() >= 1024 ? "top center" : "top bottom",
					end: $(window).width() >= 1024 ? "+=100%" : "+=70%",
					scrub: true,
				},
			});
		});

        var image = section.find('.image-container');
        if (image.length) {
			gsap.to(image, {
				height: '100%',
				scrollTrigger: {
					trigger: section[0],
					start: $(window).width() >= 1024 ? "top top" : "top center",
					end: $(window).width() >= 1024 ? "+=200%" : "+=100%",
					scrub: true,
				},
			});
        }
	});
}


// --- //


function animationType2() {

	if ($(window).width() < 1024) return false;

    var animationType2Section = $('[data-section="animationType2"]');
	if (!animationType2Section.length) return false;

	animationType2Section.each(function() {
		var section = $(this);

		var animationType2Circle1 = section.find('.block-content-1');
		var animationType2Circle2 = section.find('.block-content-2');
		var animationType2Circle3 = section.find('.block-content-3');
		var animationType2Circle4 = section.find('.block-content-4');
		var animationType2Circle5 = section.find('.block-content-5');
		var animationType2Circle5Circle = animationType2Circle5.find('.circle rect');
		var animationType2Circle5Square = animationType2Circle5.find('.square rect');

		gsap.set(animationType2Circle5Circle, {
			strokeDasharray: 2000,
			strokeDashoffset: 2000,
		});
		gsap.set(animationType2Circle5Square, {
			strokeDasharray: 2000,
			strokeDashoffset: 2000,
		});

		var animationType2Timeline = gsap.timeline({
			scrollTrigger: {
				trigger: section[0],
				start: "top top",
				end: "+=100%",
				scrub: true,
				pin: true,
				anticipatePin: 2,
				pinSpacing: false,
			},
		});

		animationType2Timeline.to(animationType2Circle1, {
			scale: 1,
		})
		.to(animationType2Circle2, { 
			scale: 1,
		}, "-=0.4")
		.to(animationType2Circle3, { 
			scale: 1,
		}, "-=0.4")
		.to(animationType2Circle4, { 
			scale: 1,
		}, "-=0.4")
		.to(animationType2Circle5, { 
			scale: 1,
		}, "-=0.4")
		.to(animationType2Circle5Circle, {
			strokeDashoffset: 0,
		}, "-=0.4")
		.to(animationType2Circle5Square, {
			strokeDashoffset: 0,
		}, "-=0.4")
	});

}


// --- //


function videoType2() {

    var videoType2Section = $('[data-section="videoType2"]');
	if (!videoType2Section.length) return false;

    var videoType2TabTrigger = videoType2Section.find('[data-tab-trigger]');
	var videoType2SectionVideos = $('[data-section="videoType2"][data-tab]');
	
	videoType2TabTrigger.on('click', function () {
        var id = $(this).attr('data-tab-trigger');
		videoType2SectionVideos.hide();
		videoType2TabTrigger.removeClass('active');
		videoType2Section.find('[data-tab-trigger="' + id + '"]').addClass('active');
		$('[data-section="videoType2"][data-tab="' + id + '"]').show();

    });
}


// --- //


function imagesType1() {

	if ($(window).width() < 1280) return false;

    var imagesType1Section = $('[data-section="imagesType1"]');
	if (!imagesType1Section.length) return false;

	imagesType1Section.each(function() {
		var section = $(this);
		var imagesType1Image = section.find('.image-container');
		
		gsap.to(imagesType1Image, {
			yPercent: -10,
			ease: "none",
			scrollTrigger: {
				trigger: section[0],
				start: "top bottom",
				end: "bottom top",
				scrub: true,
			},
		});
	});

}


// --- //


function listType1() {

	if ($(window).width() < 1280) return false;

    var listType1Section = $('[data-section="listType1"]');
	if (!listType1Section.length) return false;

	var listType1SectionSiblings = $('[data-section="listType1"] + [data-section="listType1"]');

	if (!listType1SectionSiblings.length) return false;

	var listType1SectionFirst = $('[data-section="listType1"]').first();
	var listType1SectionFirstContainer = listType1SectionFirst.find('.container');
		
	gsap.to(listType1SectionFirst, {
		ease: "none",
		scrollTrigger: {
			trigger: listType1SectionFirst[0],
			start: "top top",
			end: "bottom top",
			scrub: true,
			pin: true,
			anticipatePin: 2,
			pinSpacing: false,
		},
	});
	gsap.to(listType1SectionFirstContainer, {
		ease: "none",
		opacity: 0,
		scrollTrigger: {
			trigger: listType1SectionFirst[0],
			start: "top top",
			end: "bottom top",
			scrub: true,
		},
	});

}


// --- //


function animationType3() {

    var animationType3Section = $('[data-section="animationType3"]');
	if (!animationType3Section.length) return false;
	var logo = animationType3Section.find('img');

	console.log("localStorage.getItem('hierarchySplash') " + localStorage.getItem('hierarchySplash'))
	if (!localStorage.getItem('hierarchySplash')) {
		logo.fadeIn();
		var tl = gsap.timeline({
			scrollTrigger: {
				trigger: animationType3Section[0],
			},
			onComplete: function() {
				animationType3Section.hide();
				heroType1();
			}
		});
	
		tl.to(logo, { 
			scale: 1, 
			duration: 1,
			delay: 1,
			ease: "Linear.easeNone",
		}).to(logo, { 
			scale: 200, 
			duration: 2,
			delay: 1,
			ease: "Linear.easeNone",
		}).to(animationType3Section, { 
			opacity: 0, 
			duration: 0.1,
			ease: "Linear.easeNone",
		}, "-=1")
	} else {
		animationType3Section.hide();
		heroType1();
	}
	localStorage.setItem('hierarchySplash', 'true');
}


// --- //


///////////////////////////////////////




// FILTER LIST TYPE 2

var listType2Section = $('[data-section="listType2"]');
var rowList = listType2Section.find(".row.row-list");

function listType2() {

	if (!listType2Section.length) return false;

	var listType2Cards = listType2Section.find('.block-card');
	var hiddenCards = listType2Cards.filter('.hidden').detach(); // Detach hidden cards to stash them
    
	// rowList.empty().append(listType2Cards.not('.hidden').sort((a, b) => $(a).index() - $(b).index()));
	rowList.empty().append(listType2Cards.sort((a, b) => {
		return $(a).data('index') - $(b).data('index');
	}));

	if ($(window).width() < 1024) {
		var numColumns = 2;
	} else {
		var numColumns = 3;
	}
	
    for (let i = 0; i < numColumns; i++) {
        const column = $("<div>").addClass("column");
		listType2Cards.not('.hidden').filter((index) => index % numColumns === i).appendTo(column);
        
        rowList.append(column);
    }

	rowList.append(hiddenCards);
	
	var listType2ColumnOne = listType2Section.find('.row-list .column:first-child');
	var listType2ColumnTwo = listType2Section.find('.row-list .column:nth-child(2)');
	var listType2ColumnThree = listType2Section.find('.row-list .column:last-child');
	ScrollTrigger.matchMedia({
		"(min-width: 1024px)": function () {
			gsap.to(listType2ColumnOne, {
				marginTop: '-15vh',
				duration: 1,
				scrollTrigger: {
					trigger: listType2Section[0],
					start: "top center",
					end: "bottom center",
					scrub: true,
				},
			});
			gsap.to(listType2ColumnTwo, {
				marginTop: '15vh',
				duration: 1,
				scrollTrigger: {
					trigger: listType2Section[0],
					start: "top center",
					end: "bottom center",
					scrub: true,
				},
			});
			gsap.to(listType2ColumnThree, {
				marginTop: '-15vh',
				duration: 1,
				scrollTrigger: {
					trigger: listType2Section[0],
					start: "top center",
					end: "bottom center",
					scrub: true,
				},
			});
		},
		"(max-width: 1023px)": function () {
			listType2ColumnOne.removeAttr('style');
			listType2ColumnTwo.removeAttr('style');
			listType2ColumnThree.removeAttr('style');
		}
	});
	
}


$(function () {
	
	listType2();
	
	if (listType2Section.length) {
		var filter = getUrlParameter('filter');
		var filterButton = listType2Section.find('[data-filter-option="' + filter + '"]');
		if (filterButton.length) {
			filterButton.trigger('click')
		} else {
			ScrollTrigger.refresh();
		}
	}

});


$(window).on('resize', function() {

	if (listType2Section.length) {
		if ($(window).width() < 768) {
			var numColumns = 1;
		} else if ($(window).width() < 1024) {
			var numColumns = 2;
		} else {
			var numColumns = 3;
		}

		var currentColumns = rowList.find('.column').length;
		if (numColumns != currentColumns) {
			console.log('currentColumns ' + currentColumns)
			listType2();
		}

	}

});

$(document).on('click', '[data-filter-trigger]', function(e) {
	var filterElement = $(this).closest('.filter');
	var action = $(this).attr('data-filter-trigger');
	filterButtonAction(filterElement, action);
});

$(document).on('click', '[data-filter-option]', function(e) {
	var filter = $(this).attr('data-filter-option');
	var filterElement = $(this).closest('.filter');
	var listType2Section = $(this).closest('section');
	if (filter == 'all') {
		filterElement.find('.heading').text('Filter');
		filterElement.find('.heading').removeClass('selected');
		filterElement.removeClass('selected');
		listType2Section.find('.block-card').removeClass('hidden');
	} else {
		filterElement.find('.heading').text($(this).text());
		filterElement.find('.heading').addClass('selected');
		filterElement.addClass('selected');
		listType2Section.find('.block-card').addClass('hidden');
		listType2Section.find('.block-card.' + filter).removeClass('hidden');
	}

    var currentUrl = window.location.href;
    currentUrl = decodeURIComponent(currentUrl);
    var url = new URL(currentUrl);
    url.searchParams.set('filter', filter);
    window.history.replaceState({}, document.title, url.toString());

	filterButtonAction(filterElement, 'close');
	
	listType2();
	
	ScrollTrigger.refresh();

	$('html, body').animate({
		scrollTop: listType2Section.offset().top
	}, 500);
});

function filterButtonAction(filterElement, action) {
    var filterOptions = filterElement.find('.options');
    var filterHeading = filterElement.find('.heading');
    var filterClose = filterElement.find('.close');

    var filterTimeline = gsap.timeline({
        defaults: { duration: 0.8, ease: 'power2.out' },
        paused: true,
    });

    if (action === 'open') {
        filterOptions.css('display', 'block');
		filterElement.addClass('open');
        filterTimeline
			.to(filterHeading, { 
				opacity: 0,
				duration: 0.1,
				pointerEvents: 'none', 
			}, '<')
			.to(filterClose, { 
				opacity: 1, 
				pointerEvents: 'auto', 
			}, '<')
            .to(filterElement, { 
				height: filterOptions.outerHeight(),
				width: filterOptions.outerWidth(),
			}, '<')
            .to(filterOptions, { 
				opacity: 1, 
				pointerEvents: 'auto', 
			}, '<');
        filterTimeline.timeScale(1).play();
    } else {
		filterElement.removeClass('open');
        filterTimeline
			.to(filterHeading, { 
				opacity: 1,
				pointerEvents: 'auto', 
			}, '<')
			.to(filterClose, { 
				opacity: 0, 
				pointerEvents: 'none', 
			}, '<')
            .to(filterOptions, { 
				opacity: 0, 
				pointerEvents: 'none', 
			}, '<')
            .to(filterElement, { 
				height: filterHeading.outerHeight(),
				width: filterHeading.outerWidth(),
			}, '<')
            .to(filterOptions, { 
				opacity: 0, 
			}, '<');
        filterTimeline.timeScale(2).play();
    }
}

// --- //


///////////////////////////////////////




// IFRAME

$(document).on('click', '[data-close-iframe]', function(e) {
	if (window.self !== window.top) {
		// window.parent.$('iframe.iframePopup').parent().removeClass('pointer-events-none');
		window.parent.$('iframe.iframePopup').remove();
    } else {
		var redirectUrl = $(this).attr('data-close-iframe');
		window.location.href = redirectUrl;
	}
});

$(document).on('click', 'a[data-iframe]', function(e) {
	e.preventDefault();
	var iframeUrl = $(this).attr('data-iframe');
    var iframe = $('<iframe>', {
        src: iframeUrl,
        class: 'iframePopup',
        frameborder: 0,
        allowfullscreen: true
    });
    $('body').append(iframe);
});
///////////////////////////////////////




// FILTER - NEWS - LIST TYPE 3

let currentPage_N = 1;
let loading_N = false;
let currentCategory_N = 'all';
const listType3Section = $('section[data-section="listType3"]');
let cardsEl_N = listType3Section.find('[data-cards]');
let loadMoreEl_N = listType3Section.find('[data-load-more]');

var ajaxRequests = {}; // these will be aborted when filtering
var cardCache = {}; // Global cache to store fetched cards




$(function () {
	
	if (listType3Section.length) {
		var filter = getUrlParameter('category');
		var filterButton = listType3Section.find('[data-filter-value="' + filter + '"]');
		if (filterButton.length) {
			filterButton.trigger('click')
		} else {
			ScrollTrigger.refresh();
		}
	}

});

$(document).on('click', 'section[data-section="listType3"] [data-filter-trigger="category"]', function (e) {
    e.preventDefault();

    currentCategory_N = $(this).attr('data-filter-value'); // Get selected category
    currentPage_N = 1; // Reset to the first page

    // Mark the clicked category as active
    $('[data-filter-trigger="category"]').removeClass('active');
    $(this).addClass('active');

    // Clear existing events and load filtered events
	
	var filterElement = $(this).closest('.filter');
	var listType3Section = $(this).closest('section');

	listType3Section.find('.row-cards').remove();
	if (currentCategory_N == 'all') {
		filterElement.find('.heading').text('Filter');
		filterElement.find('.heading').removeClass('selected');
	} else {
		filterElement.find('.heading').text($(this).text());
		filterElement.find('.heading').addClass('selected');
	}

    var currentUrl = window.location.href;
    currentUrl = decodeURIComponent(currentUrl);
    var url = new URL(currentUrl);
    url.searchParams.set('category', currentCategory_N);
    window.history.replaceState({}, document.title, url.toString());

	filterButtonAction(filterElement, 'close');
	
	ScrollTrigger.refresh();

	$('html, body').animate({
		scrollTop: listType3Section.offset().top
	}, 500);




    loadMoreNews(currentPage_N, currentCategory_N);



});

// Load more events when the button is clicked
$(document).on('click', 'section[data-section="listType3"] [data-load-more]', function (e) {
    e.preventDefault();

    if (loading_N) return; // Prevent multiple clicks
    loading_N = true;

    currentPage_N++;
    loadMoreNews(currentPage_N, currentCategory_N);
});

async function loadMoreNews(page, category = 'all') {
    try {
        const response = await $.ajax({
            type: 'get',
            url: `/news.json?page=${page}&category=${category}`,
        });

        let events = response.data;
        let limit = 5; // Assuming the response contains an array of event data
        if (events.length > 0) {
            for (const event of events) {
                try {
                    const cardHtml = await fetchCard(event.id); // Fetch card content
					// console.log(cardHtml)
                    cardsEl_N.append(cardHtml); // Append to the container
                } catch (error) {
                    console.log(`Error fetching card for event ID ${event.id}:`, error);
                }
				limit = event.limit;
            }

            loading_N = false; // Allow loading more pages
        }
		console.log('limit ' + limit)
		console.log('events.length ' + events.length)
		if (events.length < limit || events.length == 0) {
            loadMoreEl_N.attr('data-load-more','false');
		} else {
            loadMoreEl_N.attr('data-load-more','true');
		}

    } catch (error) {
        console.log('Error loading more events:', error);
    }
}

function fetchCard(id) {
	
	return new Promise((resolve, reject) => {

		if (ajaxRequests[id]) {
			ajaxRequests[id].abort(); // Abort the previous request for the same card ID
		}

		if (cardCache[id]) {
			resolve(cardCache[id]);
		} else {
			ajaxRequests[id] = $.ajax({
				type: 'get',
				url: '/card-article/' + id,
				success: function (response) {
					console.log('fetchCard success for id: ' + id);
					// console.log(response)
					cardCache[id] = response;
					delete ajaxRequests[id]; // Remove the request reference when it's completed
					resolve(response);
				},
				error: function (error) {
					console.log('Error fetchCard for id: ' + id);
					console.log(error);
					delete ajaxRequests[id]; // Remove the request reference when it's completed
					reject(error);
				},
			});
		}
	});
}

////////////////////